import React from 'react';
import {
        Show,
        ShowButton,
        Tab,
        TabbedShowLayout,
        DateField,
        List,
        Edit,
        Create,
        Datagrid,
        TextField,
        EditButton,
        ReferenceManyField,
        SingleFieldList,
        ChipField,
        SimpleForm,
        TextInput,
} from 'react-admin';

import LinkAnyFieldButton from './LinkAnyFieldButton';

export const IdpList = props => (
    <List {...props} >
        <Datagrid>
            <TextField source="name" />
            <TextField source="url" />
            <TextField source="type" />
            <ReferenceManyField label="Client" reference="ClientIdpView" target="idpId" linkType="none" >
                <SingleFieldList linkType={false} >
                    <LinkAnyFieldButton to="/Client/:clientId/show">
                        <ChipField source="clientName" />
                    </LinkAnyFieldButton>
                </SingleFieldList>
            </ReferenceManyField>
            <EditButton />
            <ShowButton />
        </Datagrid>
    </List>
);

const IdpTitle = ({ record }) => {
    return <span>Idp: {record ? `${record.name}` : ''}</span>;
};

export const IdpEdit = props => (
    <Edit title={<IdpTitle />} {...props}>
        <SimpleForm>
            <TextInput disabled source="id" />
            <TextInput source="name" />
            <TextInput source="url" />
            <TextInput source="type" />
        </SimpleForm>
    </Edit>
);

export const IdpCreate = props => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="name" />
            <TextInput source="url" />
            <TextInput source="type" />
        </SimpleForm>
    </Create>
);

export const IdpShow = props => (
    <Show title={<IdpTitle />} {...props}>
        <TabbedShowLayout>
            <Tab label="summary" >
                <TextField source="name" />
                <TextField source="url" />
                <TextField source="type" />
                <DateField label="Publication date" source="createdAt" />
            </Tab>
            <Tab label="Usage" >
            <ReferenceManyField label="Client" reference="ClientIdpView" target="idpId" linkType={false} >
                <SingleFieldList linkType={false} >
                    <LinkAnyFieldButton to="/Client/:clientId/show">
                        <ChipField source="clientName" />
                    </LinkAnyFieldButton>
                </SingleFieldList>
            </ReferenceManyField>
            </Tab>
        </TabbedShowLayout>
    </Show>
);
